export default class B66B67Helper {
    constructor(app, configuration = null) {
        this.app = app;
        this.oldValue = null
        this.configuration = configuration
    }

    getConfiguration(){
        if( !this.app.currentConfiguration && !this.configuration ) return null;

        if( this.configuration ) return this.configuration;

        return this.app.currentConfiguration
    }
    /**
     * Estem en gama 66 o 67
     * @returns bool
     */
    is66or67() {
        let configuration = this.getConfiguration()
        if( !configuration ) return false;
        if( configuration.familyParameters.length == 0 ) return false;
        if( !configuration.familyParameters["gama"] ) return false;

        let idgama = configuration.familyParameters["gama"].value.id;

        if (idgama == '66' || idgama == '67') return true;

        return false
    }

    /**
     * La distància entre suports és correcte
     * @returns bool
     */
    isDistanceOk() {
        if (this.isTramosDistintos())
            return true;

        if (this.isNoMetadata())
            return true;

        if (this.isNoCalcAvailable()) {
            return false
        } else
            if (this.isNoDistanceAvailable()) {
                return false
            } else if (this.isProposedDistance()) {
                return true
            } else {
                return true
            }
    }

    /**
     * Missatge d'advertència o error de la distància entre suports
     * @returns string
     */
    getDistanceMessage() {
        if (this.isTramosDistintos()) {
            // TODO: no res??
            return "";
        }
        if (this.isNoCalcAvailable()) {
            return this.app.translate("s3_no_calculation_alert")
        } else if (this.isNoDistanceAvailable()) {
            return this.app.translate("s3_no_support_alert")
        } else if (this.isProposedDistance()) {
            let result = this.app.translate("s3_min_distance_alert") +
                "<span class='font-weight-bold'>" +
                this.getConfiguration().metadata
                    .distance_supports_proposed +
                "</span>"
            return result
        } else {
            if (this.oldValue && this.oldValue.id !== this.getNewValue().id) {
                // Valor cambiado
                return this.app.translate("s3_distance_changed");
            }
            return this.app.translate("s3_must_select_distance");
        }
    }
    isNoMetadata() {
        if (this.getConfiguration().metadata == null) {
            return true;
        }
        return false;
    }
    isMetadata() {
        if (this.getConfiguration().metadata != null) {
            return true;
        }

        return false;
    }

    /**
     * Hi ha una distància proposada
     * @returns boolean
     */
    isProposedDistance() {
        if (
            this.isMetadata() &&
            this.getConfiguration().metadata.distance_supports_proposed &&
            this.getConfiguration().metadata.distance_supports_proposed !== "n/a"
        ) {
            return true;
        }
        return false;
    }

    /**
     * No hi ha distància disponible amb els elements configurats
     * @returns boolean
     */
    isNoDistanceAvailable() {

        if (
            this.isMetadata() &&
            this.getConfiguration().metadata.distance_supports_proposed &&
            this.getConfiguration().metadata.distance_supports_proposed == "n/a" &&
            this.getConfiguration().metadata.perfil_options &&
            this.getConfiguration().metadata.perfil_options['2omega'] != 'FAIL-NOCALC'
        ) {
            return true;
        }
        return false;
    }

    /**
     * No es pot calcular la distància entre suports
     * @returns boolean
     */
    isNoCalcAvailable() {

        if (
            this.isMetadata() &&
            this.getConfiguration().metadata.perfil_options &&
            this.getConfiguration().metadata.perfil_options['2omega'] == 'FAIL-NOCALC'
        ) {
            return true;
        }
        return false;
    }

    /**
     * Revisar si s'ha canviat la distància entre suports
     * @returns boolean
     */
    hasDistanceChanged() {
        if (this.oldValue && this.oldValue.id !== this.getNewValue().id) {
            // Valor cambiado
            return true;
        }
        return false;
    }

    saveOldValue() {
        let param = null
        if (this.isTramosDistintos()) {
            // Nothing
        } else {
            param = this.app.
                currentConfiguration.
                commonMainElementParameters['common_distancia_soportes']
            this.oldValue = param.value
        }
    }
    getNewValue() {
        let param = null
        if (this.isTramosDistintos()) {
            // Nothing
        } else {
            param = this.app.
                currentConfiguration.
                commonMainElementParameters['common_distancia_soportes']
            return param.value
        }
    }

    /**
     * Event: abans de que es canviï un paràmetre
     * @param {*} param
     * @param {*} value
     * @param {*} mainElement
     */
    async beforeUpdateParameter(param, value, mainElement) {
        Unex.log("Before update parameter: " + param)
        if (param == 'dimensiones') {
            this.saveOldValue()
            await this.resetDistanciaSoportes(mainElement)
        }
    }
    async afterUpdateParameter(param, value) {
        Unex.log("B66B67 - After update parameter " + param, 'Configurator')

        if (param === 'dimensiones') {
            await this.showCurrentDistanciaSoportes()
        }
    }

    /**
     * Neteja la distància entre suports
     * @param {*} mainElement
     * @returns Promise<void>
     */
    async resetDistanciaSoportes(mainElement = null) {
        // show new distancia entre soportes
        Unex.log("B66B67 - Resetting distancia_soportes", "Configurator")

        let param = null
        if (mainElement !== null && this.isTramosDistintos()) {
            // only change element distance
            param = mainElement['distancia_soportes']
        } else {
            param = this.app.
                currentConfiguration.
                commonMainElementParameters['common_distancia_soportes']
        }
        if (param) {
            param.value = ""; //{ "id": -1, "fullName":"3 m"}
        }

        return;
    }

    /**
     * Mostrar missatge emergent amb informació sobre la distància entre suports
     * @returns any
     */
    async showCurrentDistanciaSoportes() {
        // show new distancia entre soportes
        if (this.isTramosDistintos() ||
            (this.isDistanceOk() && !this.hasDistanceChanged())
        )
            return

        Unex.log("Displaying info about distancia_soportes (is ok: " + this.isDistanceOk() + ")", "Configurator")
        Unex.log(this.getDistanceMessage())
        this.app.showToast(
            this.getDistanceMessage(),
            null,
            !this.isDistanceOk()
        )

        return;

    }
    getSolucionConstructiva() {
        return this.getConfiguration().familyParameters[
            "sol_constructiva"
        ].value
    }

    /**
     * Casos en que la solució és vertical
     * @returns boolean
     */
    isVertical() {
        let sol_constructiva = this.getSolucionConstructiva().id;

        if (sol_constructiva.includes("-v")) return true;
        if (sol_constructiva === "10-t_tra") return true;
        if (sol_constructiva === "10-p_dir") return true; //ok
        if (sol_constructiva === "10-p_dir-v") return true; //ok
        if (sol_constructiva === "10-p_sv") return true; //ok
        if (sol_constructiva === "10-t_sop") return true;
        if (sol_constructiva === "10-p_sh_dir-h-common") return true;
        if (sol_constructiva === "10-p_sh_dir-h") return true;
        if (sol_constructiva === "10-p_sh_per-h") return true;
        if (sol_constructiva === "10-p_sh_per-h_strut") return true;

        if (sol_constructiva === "10-s_dir")
            return true;
        if (sol_constructiva === "10-cliente") return true;

        return false;
    }

    /**
     * Casos en que la solució és horitzontal
     * @returns boolean
     */
    isHoritzontal() {
        return !this.isVertical();
    }

    /**
     * Casos en què es permet múltiples elements
     *
     * @returns boolean
     */
    allowMultiple() {
        let sol_constructiva = this.getSolucionConstructiva().id;

        // TODO: no hardcoded
        if (sol_constructiva === "10-p_sv-common") return true; //ok
        if (sol_constructiva === "10-p_sv") return true; //ok
        if (sol_constructiva === "10-p_sv-v") return true; //ok
        if (sol_constructiva === "10-p_dir") return true; //ok
        if (sol_constructiva === "10-t_sop") return true; //ok
        if (sol_constructiva === "10-t_tra") return true; //ok
        if (sol_constructiva === "10-p_sh_dir-h-common") return true;
        if (sol_constructiva === "10-s_dir-common") return true;
        if (sol_constructiva === "10-p_sh_dir-h") return true;
        if (sol_constructiva === "10-p_sh_dir-v") return true;
        if (sol_constructiva === "10-p_sh_per-h") return true;
        if (sol_constructiva === "10-p_sh_per-v") return true;
        if (sol_constructiva === "10-p_dir-v") return true;
        if (sol_constructiva === "10-p_dir-h") return true;
        if (sol_constructiva === "10-p_sh_per-h_strut") return true;
        if (sol_constructiva === "10-cliente") return true;
        if (sol_constructiva === "10-cliente-common") return true;
        if (sol_constructiva === "10-s_dir") return true;
        if (sol_constructiva === "10-s_sep") return true;
        if (sol_constructiva === "10-s_azot") return true;


        return false;
    }

    /**
     * Casos muntatge en trams comuns
     * @returns boolean
     */
    isTramoComun() {
        let sol_constructiva = this.getSolucionConstructiva().id

        switch (sol_constructiva) {
            // TODO: no harcodejar
            // B66
            case "10-p_sh_dir-h-common":
            case "10-p_sv-common":
            case "10-p_sh_per-h":
            case "10-p_sh_per-v":
            case "10-p_sh_per-h_strut":
            // case "10-s_dir":
            case "10-t_sop":
            case "10-cliente-common":
            case "10-s_dir-common":
            // B67
            case "10-p_sh_dir-h-common":
            // case "10-s_dir":
            case "10-t_sop":
            case "10-cliente-common":
                return true;

            default:
                return false;
        }
    }

    /**
     *
     * @returns boolean
     */
    isTramosDistintos() {
        return !this.isTramoComun();
    }

    showCommonParameter(parameter) {

        if (parameter.parameter_definition &&
            parameter.parameter_definition.attribute_id == "altura_trabajo") {
            let sol_constructiva = this.getSolucionConstructiva().id;
            // Només mostrar en solucions constructives de sostre
            if (sol_constructiva !== "10-t_sop") return false; //ok
        }
        return true
    }


    /**
     *
     * @returns boolean
     */
    mustShowDistanciaEntreSoportes(){
        return true;

        let solucion = this.getSolucionConstructiva()

        switch(solucion.id){
            case '10-p_dir':
            case '10-s_dir':
            case '10-p_dir-v':
            case '50-cuadr_maq':
                return false;
        }

        return true;
    }

    // SOPORTAJE
    isWall() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (sol_constructiva.includes("10-p")) return true;

        return false;
    }
    isFloor() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (sol_constructiva.includes("10-s")) return true;
        if (sol_constructiva.includes("10-s_azot")) return true;

        return false;
    }
    isCeiling() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (sol_constructiva.includes("10-t")) return true;

        return false;
    }

    withPerfil() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (sol_constructiva.includes("per")) return true;
        if (sol_constructiva === "10-t_sop") return true;
        if (sol_constructiva === "10-s_azot") return true;
        // if (sol_constructiva === "10-p_sh_per-h_strut") return true;

        return false;
    }
    withPerfilDirectoAPared() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (
            sol_constructiva === "10-p_sh_per-h" ||
            sol_constructiva === "10-p_sh_per-v" ||
            sol_constructiva === "10-p_sh_per-h_strut"
        )
            return true;
        return false;
    }
    fijadaDirectamente() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (
            sol_constructiva === "10-p_dir" ||
            sol_constructiva === "10-s_dir" ||
            sol_constructiva === "10-p_dir-v"
        )
            return true;
        return false;
    }
    withSoportajeCliente() {
        let sol_constructiva = this.getSolucionConstructiva().id

        // TODO: deprecated
        if (sol_constructiva === "10-cliente") return true;
        if (sol_constructiva === "10-cliente-common") return true;

        return false;
    }
    withSoporteHorizontal() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (sol_constructiva === "10-t_sop") return true;
        if (sol_constructiva === "10-p_sh_per-h") return true;
        if (sol_constructiva === "10-p_sh_per-h-common") return true;
        if (sol_constructiva === "10-p_sh_per-v") return true;
        if (sol_constructiva === "10-p_sh_per-h_strut") return true;
        // if (sol_constructiva === "10-s_azot") return true;
    }
    withSoporteHorizontalDirectoPared() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (sol_constructiva === "10-p_sh_dir-h-common") return true;
        if (sol_constructiva === "10-p_sh_dir-h") return true;
        if (sol_constructiva === "10-p_sh_dir-v") return true;

    }
    withSoporteVertical() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (sol_constructiva.includes("sv")) return true;
    }
    withSoporteTrapecio() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (sol_constructiva === "10-t_tra") return true;
    }
    withSoporteSeparador() {
        let sol_constructiva = this.getSolucionConstructiva().id

        if (sol_constructiva === "10-s_sep") return true;
        if (sol_constructiva === "10-s_azot") return true;
    }
    trayImageRotation() {
        if (this.withSoportajeCliente()) return 0;
        if (this.isWall() && this.fijadaDirectamente()) return 90;
        if (this.isWall() && this.withSoporteVertical()) return 90;
        return 0;
    }

}

